import { render, staticRenderFns } from "./CustomLinks.vue?vue&type=template&id=003060ed&scoped=true&"
import script from "./CustomLinks.vue?vue&type=script&lang=js&"
export * from "./CustomLinks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "003060ed",
  null
  
)

export default component.exports